// Copyright (c) 2017 Deere & Company

export default [
    ['responsibleAccount', 'account'],
    ['responsibleAccount', 'industryIndicator'],
    ['responsibleAccount', 'location', 'city'],
    ['responsibleAccount', 'location', 'state'],
    ['responsibleAccount', 'name'],
    ['requestId']
];



// WEBPACK FOOTER //
// ./src/claim/mass-labor-rate-request-status-details/constants/filter-options.js